import { useNavigate, useParams } from "react-router-dom";
import DiffViewer from "admin/components/dataset-detail/DiffViewer";
import SyncControls from "admin/components/dataset-detail/SyncControls";
import useDatasetDiff from "admin/components/dataset-detail/hooks/useDatasetDiff";
import { DATASET_DETAIL_PAGE_TITLE } from "admin/types/constants/page-titles";
import { ArrowLeft } from "lucide-react";
import { Button } from "~/components/ui/button";
import useAppHeader from "~/contexts/header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { NEXTGEN_MAX_CONTENT_WIDTH } from "~/lib/layout";
import { nextgenAdminDatasetsPath } from "~/pages/manifold-nextgen/paths";
import { ROUTE_ADMIN, ROUTE_DATASETS } from "~/router/constants";

const DatasetDetail = ({ isNextGen = false }: { isNextGen?: boolean }) => {
  const maxContentWidth = isNextGen ? NEXTGEN_MAX_CONTENT_WIDTH : undefined;
  const maxContentWidthStyle = maxContentWidth
    ? { maxWidth: maxContentWidth, margin: "0 auto" }
    : undefined;

  useDocumentTitle(DATASET_DETAIL_PAGE_TITLE);
  useAppHeader({ title: DATASET_DETAIL_PAGE_TITLE });

  const { datasetId } = useParams();
  const navigate = useNavigate();
  const { data: diffData, isLoading, error, mutate } = useDatasetDiff();

  return (
    <div className="h-full flex flex-col">
      <div
        className="flex w-full flex-col space-y-6 pt-6 pb-8 px-6 shrink-0"
        style={maxContentWidthStyle}
      >
        <div className="flex items-start gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() =>
              navigate(isNextGen ? nextgenAdminDatasetsPath() : `${ROUTE_ADMIN}/${ROUTE_DATASETS}`)
            }
            aria-label="Back to datasets"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div className="space-y-1">
            <h1 className="text-[30px] font-semibold leading-[36px] tracking-[0.4px] text-foreground">
              Dataset Admin
            </h1>
            <p className="text-sm font-normal leading-5 tracking-[-0.15px] text-muted-foreground font-mono">
              {datasetId}
            </p>
          </div>
        </div>
      </div>

      <div className="flex w-full flex-1 flex-col gap-6 px-6 pb-6" style={maxContentWidthStyle}>
        <div className="flex flex-col gap-2">
          <h2 className="text-base font-semibold">Diff</h2>
          <p className="text-sm text-muted-foreground">
            Differences between Catalog and Access Controller state for this dataset.
          </p>
          <DiffViewer diffData={diffData} isLoading={isLoading} error={error} />
        </div>

        <SyncControls onSyncComplete={() => mutate()} />
      </div>
    </div>
  );
};

export default DatasetDetail;
